import React from "react";
import Header from "./Header";
import "../assets/styles/TermsandConditions.css";
import { TOEFL_PROGRAM_ID } from "../constants/Constants";

const TermsAndConditions = ({ toNextPage }) => {
  const programId = sessionStorage.getItem("program_id");
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "85vh" }}>
      <Header />
      <div style={{ flex: "1 1" }}>
        <div className="t-and-c-container">
          <h3>Terms and conditions</h3>
          <p className="t-and-c-contents">
            To review the Entrust Identity Verification Terms of Service, use
            the following link.
          </p>
          <a
            href="https://www.ets.org/legal/terms.html"
            target="_blank"
            className="t-and-c-links"
          >
            IDVaaS Terms of Service
          </a>
          <p className="t-and-c-contents">
            By continuing, you accept the Terms of Service.
          </p>
        </div>
        <div className="button-container">
          <button
            className={`continue-button ${
              programId == TOEFL_PROGRAM_ID
                ? "toefl-button-bg"
                : "gre-button-bg"
            }`}
            onClick={toNextPage}
          >
            CONTINUE
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
